import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getActiveTraceHttpRequestHeaders } from '@atlaskit/react-ufo/experience-trace-id-context';
import { fg } from '@atlaskit/platform-feature-flags';
import { addFeatureFlagAccessed } from '@atlaskit/react-ufo/feature-flags-accessed';
import { buildCredentials } from './types';
var defaultRequestServiceOptions = {};
var buildUrl = function buildUrl(baseUrl) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var queryParams = arguments.length > 2 ? arguments[2] : undefined;
  var secOptions = arguments.length > 3 ? arguments[3] : undefined;
  var searchParam = new URLSearchParams(
  // For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
  // Since we only care about search params it is fine to have any base url here.
  new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
  baseUrl = baseUrl.split('?')[0];
  if (queryParams) {
    for (var key in queryParams) {
      if ({}.hasOwnProperty.call(queryParams, key)) {
        searchParam.append(key, queryParams[key]);
      }
    }
  }
  if (secOptions && secOptions.params) {
    for (var _key in secOptions.params) {
      if ({}.hasOwnProperty.call(secOptions.params, _key)) {
        var values = secOptions.params[_key];
        if (Array.isArray(values)) {
          for (var i = 0; i < values.length; i++) {
            searchParam.append(_key, values[i]);
          }
        } else {
          searchParam.append(_key, values);
        }
      }
    }
  }
  var separator = '';
  if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) {
    separator = '/';
  }
  var params = searchParam.toString();
  if (params) {
    params = '?' + params;
  }
  return "".concat(baseUrl).concat(separator).concat(path).concat(params);
};
var addToHeaders = function addToHeaders(headers, keyValues) {
  if (keyValues) {
    for (var key in keyValues) {
      if ({}.hasOwnProperty.call(keyValues, key)) {
        var values = keyValues[key];
        if (Array.isArray(values)) {
          for (var i = 0; i < values.length; i++) {
            headers[key] = values[i];
          }
        } else {
          headers[key] = values;
        }
      }
    }
  }
};
var buildHeaders = function buildHeaders(secOptions, extraHeaders) {
  var headers = {};
  addToHeaders(headers, extraHeaders);
  if (secOptions) {
    addToHeaders(headers, secOptions.headers);
  }
  return headers;
};

/**
 * @returns Promise containing the json response
 */
var _requestService = function requestService(serviceConfig, options) {
  var url = serviceConfig.url,
    securityProvider = serviceConfig.securityProvider,
    refreshedSecurityProvider = serviceConfig.refreshedSecurityProvider;
  var _ref = options || defaultRequestServiceOptions,
    path = _ref.path,
    queryParams = _ref.queryParams,
    requestInit = _ref.requestInit;
  var secOptions = securityProvider && securityProvider();
  var requestUrl = buildUrl(url, path, queryParams, secOptions);
  var headers = buildHeaders(secOptions, requestInit && requestInit.headers);
  var credentials = buildCredentials(secOptions);
  var ignoreResponsePayload = (options === null || options === void 0 ? void 0 : options.ignoreResponsePayload) || false;

  //Get tracing headers from UFO
  var TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
  var tracingHeaderEnabled = fg('platform_collab_provider_tracingheaders');
  addFeatureFlagAccessed(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
  var tracingHeaders = {};
  if (tracingHeaderEnabled) {
    tracingHeaders = getActiveTraceHttpRequestHeaders(url);
  }
  var requestOptions = _objectSpread(_objectSpread({}, requestInit), {}, {
    // populate headers mainly for the collab provider however
    // other components which uses this util can get the header as well.
    // Those tracing headers shall not incur any issues as long as backends handle them properly
    headers: _objectSpread(_objectSpread({}, headers), tracingHeaders),
    credentials: credentials
  });
  return fetch(requestUrl, requestOptions).then(function (response) {
    if (response.status === 204) {
      return Promise.resolve();
    } else if (response.ok) {
      return ignoreResponsePayload ? Promise.resolve() : response.json();
    } else if (response.status === 401 && refreshedSecurityProvider) {
      // auth issue - try once
      return refreshedSecurityProvider().then(function (newSecOptions) {
        var retryServiceConfig = {
          url: url,
          securityProvider: function securityProvider() {
            return newSecOptions;
          }
        };
        return _requestService(retryServiceConfig, options);
      });
    }
    return Promise.reject({
      code: response.status,
      reason: response.statusText
    });
  });
};
export { _requestService as requestService };